import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import './propTypes.js';
import Type from './Type.js';

const Li = props => /*#__PURE__*/React.createElement(Type, _extends({
  display: "list-item"
}, props), props.children);
Li.defaultProps = {
  tag: 'li',
  font: 'p'
};

export { Li as default };
